import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Tooltip } from "@mui/material";
import { UserRank } from "@types_def/models/user.type";
import { useTranslation } from "react-i18next";

import { useBulkSelectionActionVisibility } from "./use-bulk-selection-action-visibility";

export function BulkDuplicateAction() {
  const visible = useBulkSelectionActionVisibility({
    requireAdmin: false,
    minRank: UserRank.MAINTAINER,
  });
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Tooltip title={t("delivery.action.duplicate.title")}>
      <span>
        <Button
          color="error"
          disabled
          size="small"
          startIcon={<ContentCopyIcon fontSize="small" />}
          variant="contained"
        >
          {t("delivery.action.duplicate.text")}
        </Button>
      </span>
    </Tooltip>
  );
}
